<template>
  <v-btn-toggle
    v-model="selected"
    background-color="primary"
    tile
    color="primary"
    group
  >
    <v-btn 
      v-for="option in options" 
      :value="option.value"
      :key="option.value"
    >
      {{ option.text }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>


  export default {
    name: 'MultiSwitch',

    props: {
      options: {
        type: Array,
        default: () => [],
      }
    },



    data () {
      return {
        selected: 'all',
      }
    },
  };
</script>

<style lang="scss" scoped>
  .v-btn-toggle--group {
    background-color: white;
    border-radius: 20.5px;

    button {
      background-color: white;
      margin: 0 !important;
      border: 0px !important;
      border-radius: 20.5px !important;
    }

  }
</style>